import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Instagram, Facebook, MessageCircle, X } from 'lucide-react';

export default function FloatingContact() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="dwk-fab" aria-live="polite">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.9 }}
            transition={{ duration: 0.25 }}
            className="flex flex-col gap-2"
          >
            <a
              href="https://www.instagram.com/dowakum.iraq/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="fab-instagram"
              className="group inline-flex items-center gap-3 rounded-full pl-4 pr-4 py-2.5 text-sm font-medium text-white shadow-[0_15px_40px_-12px_rgba(137,72,195,0.55)] backdrop-blur-xl"
              style={{ background: 'linear-gradient(135deg, #8948C3 0%, #005CFF 100%)' }}
            >
              <Instagram size={16} />
              {t('floating.instagram')}
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100083034836178"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="fab-facebook"
              className="group inline-flex items-center gap-3 rounded-full pl-4 pr-4 py-2.5 text-sm font-medium text-white shadow-[0_15px_40px_-12px_rgba(0,92,255,0.55)] backdrop-blur-xl"
              style={{ background: 'linear-gradient(135deg, #005CFF 0%, #40D3BE 100%)' }}
            >
              <Facebook size={16} />
              {t('floating.facebook')}
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        data-testid="fab-toggle"
        aria-label="Contact us"
        onClick={() => setOpen((v) => !v)}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: 'spring', stiffness: 200, damping: 20 }}
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.95 }}
        className="group relative inline-flex items-center gap-2 rounded-full px-4 py-3 md:px-5 md:py-3 text-white font-semibold shadow-[0_20px_50px_-15px_rgba(137,72,195,0.7)]"
        style={{ background: 'linear-gradient(135deg, #8948C3 0%, #005CFF 55%, #40D3BE 100%)' }}
      >
        <span className="absolute inset-0 rounded-full opacity-70 blur-lg -z-10"
              style={{ background: 'linear-gradient(135deg, #8948C3, #40D3BE)' }} aria-hidden="true" />
        {open ? <X size={16} /> : <MessageCircle size={16} />}
        <span className="hidden md:inline text-sm">{t('floating.label')}</span>
      </motion.button>
    </div>
  );
}
